
 
        <table mat-table [dataSource]="dataSource"  style=" height: 100px!important;width: 100%;">
  
          <!-- Position Column -->
          <ng-container matColumnDef="numeroFiche">
            <th mat-header-cell *matHeaderCellDef> No. </th>
            <td mat-cell *matCellDef="let element"> 

<button mat-icon-button [routerLink]="['/invoices',{idClient:idClient , idfacture:element.idfacture}]" routerLinkActive="router-link-active" ><mat-icon>edit</mat-icon></button>

          <span  *ngIf="element.numeroFiche">
            {{element.numeroFiche}} 
          </span>     
          <span *ngIf="!element.numeroFiche">
            {{element.idfacture}} 
          </span> 

            </td>
          </ng-container>
  
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Invoice Date </th>
            <td [ngStyle]="{'background-color': element.type=='Principal' ? 'red' : 'none',
            'color': element.type=='Principal' ? 'white' : 'none'
        
        }" mat-cell *matCellDef="let element">
                
               
                
                {{element.datefacture | date}} </td>
          </ng-container>
  
  
          <ng-container matColumnDef="ttc">
            <th mat-header-cell *matHeaderCellDef>TTC </th>
            <td mat-cell *matCellDef="let element"> {{element.montantttc | currency:element.devise+' '}} </td>
          </ng-container>
  
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;" (click)="selectRow(row)"
            [style.background]="row == selectedInvoice ? 'lightblue' : ''"></tr>
        </table>


        
 
      <button mat-raised-button (click)="createNew()">
        <mat-icon>add</mat-icon> New Invoice
      </button>
      <button mat-raised-button *ngIf=" selectedInvoice && !selectedInvoice.numeroFiche" (click)="deleteInoice()">
        <mat-icon>remove</mat-icon> Remove Invoice
      </button>
  
      <button mat-raised-button *ngIf=" selectedInvoice && selectedInvoice.dateenvoicontrat &&  selectedInvoice.aclasser  &&  selectedInvoice.numeroFiche && selectedInvoice.type!='Avoir'" (click)="avoirFactureSelected()">
        <mat-icon>edit</mat-icon> Facture d'avoir
      </button>
  
      <button mat-raised-button *ngIf=" selectedInvoice && !selectedInvoice.dateenvoicontrat &&  selectedInvoice.aclasser && selectedInvoice.type!='Avoir'" (click)="classerFacture(false)">
          <mat-icon>edit</mat-icon>Déverrouiler Facture
        </button>
  
        <button mat-raised-button *ngIf=" selectedInvoice && selectedInvoice.numeroFiche &&  !selectedInvoice.aclasser && selectedInvoice.type!='Avoir'" (click)="classerFacture(true)">
            <mat-icon>edit</mat-icon>Verrouiler Facture
          </button>
        
          <app-facture-dialog [visible]="editVisible" (closeFacture)="editVisible=false" [facture]="selectedInvoice"></app-facture-dialog>